<script>
export default {
  name: 'KeyLeft',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="vuesax/bold/key">
      <path
        id="Vector"
        d="M19.7899 4.72007C16.8299 1.77007 12.0299 1.77007 9.0899 4.72007C7.0199 6.77007 6.3999 9.72007 7.1999 12.3201L2.4999 17.0201C2.1699 17.3601 1.9399 18.0301 2.0099 18.5101L2.3099 20.6901C2.4199 21.4101 3.0899 22.0901 3.8099 22.1901L5.9899 22.4901C6.4699 22.5601 7.1399 22.3401 7.4799 21.9901L8.2999 21.1701C8.4999 20.9801 8.4999 20.6601 8.2999 20.4601L6.3599 18.5201C6.0699 18.2301 6.0699 17.7501 6.3599 17.4601C6.6499 17.1701 7.1299 17.1701 7.4199 17.4601L9.3699 19.4101C9.5599 19.6001 9.8799 19.6001 10.0699 19.4101L12.1899 17.3001C14.7799 18.1101 17.7299 17.4801 19.7899 15.4301C22.7399 12.4801 22.7399 7.67007 19.7899 4.72007ZM14.4999 12.5001C13.1199 12.5001 11.9999 11.3801 11.9999 10.0001C11.9999 8.62007 13.1199 7.50007 14.4999 7.50007C15.8799 7.50007 16.9999 8.62007 16.9999 10.0001C16.9999 11.3801 15.8799 12.5001 14.4999 12.5001Z"
        :fill="color"
      />
    </g>
  </svg>
</template>
